// Cognito redirect target. react-oidc-context handles the code exchange
// automatically when the page loads with `?code=...` in the URL. We just
// show a spinner and bounce to home once auth completes.

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Spinner } from '@cloudscape-design/components';
import { useAuth } from './AuthProvider.jsx';

export default function CallbackPage() {
  const { isLoading, isAuthenticated, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (error) {
    return (
      <Box padding="xxl" textAlign="center">
        <h2>Sign-in failed</h2>
        <p>{error.message}</p>
        <button onClick={() => navigate('/')}>Back to home</button>
      </Box>
    );
  }

  return (
    <Box padding="xxl" textAlign="center">
      <Spinner size="large" />
      <Box variant="p" margin={{ top: 'm' }}>Completing sign-in…</Box>
    </Box>
  );
}
